export const workExperienceInit = [
    {
        id: 'initial-record',
        jobTitle: '',
        company: '',
        location: '',
        from: '',
        to: '',
        roleDescription: '',
        currentlyworkHere: false,
    }
];

export const educationInfoInit = [
    {
        id: 'initial-record',
        universityName: '',
        universityId: '0',
        degree: '',
        field: '',
        GPA: '',
        from: '',
        to: '',
        didNotFinishDegree: false,
    }
];